import { render, staticRenderFns } from "./DynamicInput.vue?vue&type=template&id=09671bde&scoped=true&"
import script from "./DynamicInput.vue?vue&type=script&lang=js&"
export * from "./DynamicInput.vue?vue&type=script&lang=js&"
import style0 from "./DynamicInput.vue?vue&type=style&index=0&id=09671bde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09671bde",
  null
  
)

export default component.exports